// extracted by mini-css-extract-plugin
export var labelWrapper = "_m2-0";